import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AlertOptions } from './confirmation-dialog.interfaces';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PortfolioService, StrategySocketUpdateI, SubjectType } from '@app/_shared/providers';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';
import { ConfirmationDialogService } from './_provider/confirmation-dialog.service';
import { LOADING_TIMEOUT_MESSAGE } from '@app/_shared';
import { AuthService } from '@app/modules/auth';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {


    options: AlertOptions;
    loading = false;
    terminated = false;
    /** Tracks the state of the optional checkbox (if configured via options.checkbox). */
    checkboxChecked = false;
    count = 0;
    progressBarStartValue = 25;
    // Initialize loader with 25 percent
    value = this.progressBarStartValue;
    spinnerMode = "determinate"
    private subscriptions = new Subscription();
    isPlanChangePopup: boolean = false;

    constructor(
        public overlayContainer: OverlayContainer,
        private matDialogRef: MatDialogRef<ConfirmationDialogComponent>,
        private portfolioService: PortfolioService,
        private socketService: BooksSocketService,
        private confirmationService: ConfirmationDialogService,
        public authService: AuthService,
        @Inject(MAT_DIALOG_DATA) private dialogData
    ) {

        if (this.portfolioService.countTerminatedPortfolios) {
            this.subscriptions.add(
                this.socketService.getSubject(SubjectType.STRATEGY).subscribe((socketUpdate: StrategySocketUpdateI) => {
                    // Count terminated portfolios through stream
                    if (this.portfolioService.countTerminatedPortfolios && (socketUpdate.message || socketUpdate.TerminationMessage)) {
                        this.count++;
                        // Increase loader value
                        this.value += ((100 - this.progressBarStartValue) / this.portfolioService.totalActivePortfoliosCount) * this.count;
                        // If all portfolios terminated then call logout
                        if (this.portfolioService.totalActivePortfoliosCount <= this.count) {
                            this.terminated = true;
                            setTimeout(() => {
                                this.loading = false;
                                this.matDialogRef.close();
                                this.authService.logoutApi(this.dialogData?.socialLoginLink);
                            }, 1000)


                        }
                    }

                })
            );
        }
    }

    ngOnInit() {
        this.isPlanChangePopup = this.dialogData?.isPlanChangePopup;
        this.checkboxChecked = !!this.options?.checkbox?.checked;
        if (this.options?.enableSpin) {
            this.loading = this.options?.enableSpin;
            this.logoutTimer();
        }
    }

    execute(handler) {
        if (handler) {
            // Pass checkbox state so handlers can act on it.
            // Existing handlers that don't declare the param simply ignore it.
            handler(this.checkboxChecked);
        }

        this.matDialogRef.close();
    }

    logoutTimer() {
        // After 5 seconds change spinner mode
        setTimeout(() => {
            this.spinnerMode = "indeterminate"
        }, 5000);
        // If all portfolios didn't terminated within 30 seconds then show error dialog
        setTimeout(() => {
            if (!this.terminated) {
                this.portfolioService.countTerminatedPortfolios = false;
                this.matDialogRef.close();
                let executeFunction = () => {
                    this.authService.logoutApi(this.dialogData?.socialLoginLink)
                }

                this.confirmationService.alert({
                    message: LOADING_TIMEOUT_MESSAGE,
                    buttons: [
                        {
                            text: 'Cancel',
                            accent: true,
                            class: 'undeploy-button',
                        },
                        {
                            text: 'Confirm',
                            accent: true,
                            class: 'new-theme-gradient-bg',
                            handler: executeFunction
                        }
                    ],
                }, {
                    disableClose: true,
                });
            }
        }, 30000)

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }


}
